// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ftWCV","rootMobile":"styles_rootMobile__1IPaP"};